import LoginDTO from 'dto/identity/loginDTO';
import { IdentityProviderType } from 'models/identity/identityProvider';
import Login, { LoginTenantRestoreStates } from 'models/identity/login';
import { DefLanguageCode } from 'models/tenants/setting';
import { fromApiDateTimeOptional } from 'utils/datetime';
import { SubscriptionTypes } from 'utils/subscription';
import { mapFromGlobalDataCache } from './globalDataCacheMapping';
import { mapFromTenants } from './tenantMapping';

export function mapFromLogin(loginDTO: LoginDTO): Login {
  const newLogin = new Login();

  newLogin.tenantId = loginDTO.tenantId ?? ''; //undefined while the user's directory has no organization
  newLogin.userId = loginDTO.userId;
  newLogin.identityProviderType = loginDTO.identityProviderType ?? IdentityProviderType.Entra;
  newLogin.tenantIdentityProviderType = loginDTO.tenantIdentityProviderType ?? newLogin.identityProviderType;
  newLogin.userSystemRoles = loginDTO.userSystemRoles;
  newLogin.lastLogin = fromApiDateTimeOptional(loginDTO.lastLogin);
  newLogin.tenantLicensed = loginDTO.tenantLicensed;
  newLogin.userLicensed = loginDTO.userLicensed;
  newLogin.userLanguageCode = loginDTO.userLanguageCode;
  newLogin.trialStart = fromApiDateTimeOptional(loginDTO.trialStart);
  newLogin.globalDataCache = mapFromGlobalDataCache(loginDTO.globalDataCache);
  newLogin.defLanguageCode =
    loginDTO.defLanguageCode ?? (newLogin.globalDataCache.settings.get(DefLanguageCode) as string | undefined) ?? '';
  newLogin.subscriptionType = loginDTO.subscriptionType ?? SubscriptionTypes.Trial;
  newLogin.tenants = mapFromTenants(loginDTO.tenants);
  newLogin.isOnboardingInProgress = loginDTO.isOnboardingInProgress ?? false;
  newLogin.isPublisher = loginDTO.isPublisher ?? false;
  newLogin.tenantRestoreState = loginDTO.tenantRestoreState ?? LoginTenantRestoreStates.None;

  return newLogin;
}
